import React from 'react';
import img from "../assest/img1.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone , faLocationDot} from "@fortawesome/free-solid-svg-icons";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { faFacebookF, faTwitter, faGooglePlusG } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css"

const Footer = () => {
  return (
    <footer className="footer-section  ">
      <div className="container-sm">
        <div className="footer-cta pt-5 pb-5">
          <div className="row">
            <div className="col-xl-4 col-md-4 mb-30">
              <div className="single-cta">
              <FontAwesomeIcon className='icons' icon={faLocationDot} />
                <div className="cta-text">
                  <h4>Find us</h4>
                  <span>xyz place , chandigarh</span>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mb-30">
              <div className="single-cta">
              <FontAwesomeIcon className='icons' icon={faPhone} />
                <div className="cta-text">
                  <h4>Call us</h4>
                  <span>9823456786543</span>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 mb-30">
              <div className="single-cta">
              <FontAwesomeIcon className='icons' icon={faEnvelope} />                <div className="cta-text">
                  <h4>Mail us</h4>
                  <span>mail@info.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-content pt-5 pb-5">
          <div className="row">
            <div className="col-xl-4 col-lg-4 mb-50">
              <div className="footer-widget">
                <div className="footer-logo">
                  <a href="index.html"><img src={img} className="img-fluid" alt="logo" /></a>
                </div>
                <div className="footer-text">
                  <p>Lorem ipsum dolor sit amet, consec tetur adipisicing elit, sed do eiusmod tempor incididuntut consec tetur adipisicing elit,Lorem ipsum dolor sit amet.</p>
                </div>
              
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                <li><a href="/">Flights </a></li>
                  <li><a href="/">Trains </a></li>
                  <li><a href="/">Hotels </a></li>
                  <li><a href="/">Homestays </a></li>
                  <li><a href="/">Buses</a></li>
                  <li><a href="/">Cabs</a></li>
                  <li><a href="/">Visa</a></li>
                  <li><a href="/">Charter Flights</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Subscribe</h3>
                </div>
                <div className="footer-text mb-25">
                  <p>Don’t miss to subscribe to our new feeds, kindly fill the form below.</p>
                </div>
                <div className="subscribe-form">
                  <form action="/">
                    <input type="text" placeholder="Email Address" />
                    <button><ChevronRightIcon/></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 text-center text-lg-left">
              <div className="copyright-text">
                <p>Copyright &copy; 2023, All Right Reserved <a href="/" >Toureila</a></p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
              <div className="footer-menu">
                <ul>
                  <li><a href="/">Flights Booking</a></li>
                  <li><a href="/">Train Booking</a></li>
                  <li><a href="/">Hotel Booking</a></li>
                
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
